import toLowerKebabCase from '~/utilities/toLowerKebabCase';

export enum NewCarVariant {
  Generic = 'Generic',
  Make = 'Make',
  MakeModel = 'MakeModel'
}

type NewCarMetaData = { make?: string; model?: string };

export function getNewCarVariant(
  metaData: NewCarMetaData | undefined
): NewCarVariant {
  if (metaData?.make && metaData?.model) return NewCarVariant.MakeModel;
  if (metaData?.make) return NewCarVariant.Make;

  return NewCarVariant.Generic;
}

const SRP_REF_SOURCE = '?refSource=srp';

export function getNewCarHref(metaData: NewCarMetaData | undefined): string {
  if (metaData?.make && metaData?.model)
    return `/new/${toLowerKebabCase(metaData.make)}/${toLowerKebabCase(
      metaData.model
    )}${SRP_REF_SOURCE}`;
  if (metaData?.make)
    return `/new/${toLowerKebabCase(metaData.make)}${SRP_REF_SOURCE}`;

  return `/new${SRP_REF_SOURCE}`;
}
